/* Product-page helpers that do not depend on Liquid-generated executable code. v2 */
(function () {
  'use strict';

  var runtimeNode = document.querySelector('script[data-verychi-product-deferred-runtime]');
  if (!runtimeNode) return;

  var sectionId = runtimeNode.getAttribute('data-section-id') || '';
  var formId = runtimeNode.getAttribute('data-form-id') || '';
  var reviewsRuntimeSrc = runtimeNode.getAttribute('data-reviews-runtime-src') || '';
  var hasVpf = runtimeNode.getAttribute('data-has-vpf') === 'true';

  window.__CartMetafieldRecommendationsHtml = '';
  window.__CartMetafieldRecommendationsPending = false;
  window.__queueCartMetafieldRecommendations = function () {
    var storageKey = 'verychiCartRecommendationsHtml';
    var storageTimeKey = 'verychiCartRecommendationsSavedAt';
    var tpl = document.getElementById('CartMetafieldRecommendationsTemplate');
    if (tpl && tpl.innerHTML.trim()) {
      window.__CartMetafieldRecommendationsHtml = tpl.innerHTML;
    }
    if (window.__CartMetafieldRecommendationsHtml && window.__CartMetafieldRecommendationsHtml.trim()) {
      window.__CartMetafieldRecommendationsPending = true;
      try {
        sessionStorage.setItem(storageKey, window.__CartMetafieldRecommendationsHtml);
      } catch (err) {}
      try {
        localStorage.setItem(storageKey, window.__CartMetafieldRecommendationsHtml);
        localStorage.setItem(storageTimeKey, String(Date.now()));
      } catch (err) {}
    } else {
      window.__CartMetafieldRecommendationsPending = false;
    }
  };
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('#AddToCart--' + sectionId)) {
      window.__queueCartMetafieldRecommendations();
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.id === formId) {
      window.__queueCartMetafieldRecommendations();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var configTag = (window.SizeGuideConfig && window.SizeGuideConfig.tag) || 'SIZE_GUIDE';
    var openTag = '[' + configTag + ']';
    var closeTag = '[/' + configTag + ']';

    var contentDivs = document.querySelectorAll('.product-single__description .content');
    for (var i = 0; i < contentDivs.length; i++) {
      var contentDiv = contentDivs[i];
      var html = contentDiv.innerHTML;
      var idx = html.indexOf(openTag);
      if (idx > -1) {
        var endIdx = html.indexOf(closeTag);
        if (endIdx > -1) {
          document.getElementById('DynamicSizeGuideData').innerHTML = html.substring(idx + openTag.length, endIdx);
          contentDiv.innerHTML = html.substring(0, idx) + html.substring(endIdx + closeTag.length + 1);
        } else {
          document.getElementById('DynamicSizeGuideData').innerHTML = html.substring(idx + openTag.length);
          contentDiv.innerHTML = html.substring(0, idx);
        }
        break;
      }
    }
  });

  (function () {
    var runtimeSrc = reviewsRuntimeSrc;
    var requested = false;

    function hasMarketingConsent() {
      try {
        var consent = JSON.parse(window.localStorage.getItem('verychi_cookie_consent') || 'null');
        return !!(consent && consent.marketing);
      } catch (error) {
        return false;
      }
    }

    function loadRuntime() {
      if (requested) return;
      requested = true;
      var script = document.createElement('script');
      script.src = runtimeSrc;
      script.async = true;
      document.head.appendChild(script);
    }

    function queueRuntime() {
      if (!hasMarketingConsent()) return;
      var start = function () {
        if (window.requestIdleCallback) window.requestIdleCallback(loadRuntime, { timeout: 2000 });
        else window.setTimeout(loadRuntime, 200);
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    }

    queueRuntime();
    window.addEventListener('verychi:cookie-consent', queueRuntime);
  })();

  if (!hasVpf) return;

  (function () {
    if (window.__verychiProductPerformanceBound) return;
    window.__verychiProductPerformanceBound = true;

    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-vpf-card]');
      if (!card) return;

      var section = card.closest('.vpf-section');
      if (!section) return;

      var detail = card.parentNode ? card.parentNode.querySelector('[data-vpf-detail]') : null;
      if (!detail) return;

      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      var popup = section.querySelector('[data-vpf-popup]');
      var popupContent = section.querySelector('[data-vpf-popup-content]');
      if (!popup || !popupContent) return;

      section.querySelectorAll('[data-vpf-card]').forEach(function (otherCard) {
        otherCard.setAttribute('aria-expanded', 'false');
        otherCard.classList.remove('vpf-card--active');
      });

      card.setAttribute('aria-expanded', 'true');
      card.classList.add('vpf-card--active');
      popupContent.innerHTML = detail.innerHTML;
      popup.hidden = false;
      document.documentElement.classList.add('vpf-popup-open');
      var stickyAtc = document.getElementById('StickyMobileATC');
      if (stickyAtc) stickyAtc.classList.add('sticky-mobile-atc--popup-open');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('[data-vpf-card]');
      if (!card) return;
      event.preventDefault();
      card.click();
    });

    document.addEventListener('click', function (event) {
      var close = event.target.closest('[data-vpf-popup-close]');
      if (!close) return;

      var popup = close.closest('[data-vpf-popup]');
      var section = close.closest('.vpf-section');
      if (!popup) return;

      popup.hidden = true;
      var popupContent = popup.querySelector('[data-vpf-popup-content]');
      if (popupContent) popupContent.innerHTML = '';
      document.documentElement.classList.remove('vpf-popup-open');
      var stickyAtc = document.getElementById('StickyMobileATC');
      if (stickyAtc) stickyAtc.classList.remove('sticky-mobile-atc--popup-open');

      if (section) {
        section.querySelectorAll('[data-vpf-card]').forEach(function (card) {
          card.setAttribute('aria-expanded', 'false');
          card.classList.remove('vpf-card--active');
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-vpf-popup]').forEach(function (popup) {
        popup.hidden = true;
        var popupContent = popup.querySelector('[data-vpf-popup-content]');
        if (popupContent) popupContent.innerHTML = '';
      });
      document.documentElement.classList.remove('vpf-popup-open');
      var stickyAtc = document.getElementById('StickyMobileATC');
      if (stickyAtc) stickyAtc.classList.remove('sticky-mobile-atc--popup-open');
    });
  })();
})();
